var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetitionstopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stopwatch"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4062 10.15C15.4062 9.64944 15.0005 9.24371 14.5 9.24371C13.9995 9.24371 13.5937 9.64945 13.5937 10.15L13.5937 15.4062H8.15625C7.65574 15.4062 7.25 15.812 7.25 16.3125C7.25 16.813 7.65574 17.2188 8.15625 17.2188H14.5C14.7404 17.2188 14.9709 17.1233 15.1408 16.9533C15.3108 16.7834 15.4063 16.5528 15.4063 16.3125L15.4062 10.15Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7812 1.8125C11.7812 1.31199 12.187 0.90625 12.6875 0.90625H16.3125C16.813 0.90625 17.2188 1.31199 17.2188 1.8125C17.2188 2.31301 16.813 2.71875 16.3125 2.71875V3.75358C18.7773 4.10628 21.0134 5.16713 22.8082 6.72342C22.8155 6.71557 22.823 6.70782 22.8306 6.70017L23.4715 6.05936L22.8306 5.41854C22.4767 5.06463 22.4767 4.49082 22.8306 4.13691C23.1846 3.783 23.7584 3.783 24.1123 4.13691L26.6755 6.70017C27.0294 7.05408 27.0294 7.62789 26.6755 7.9818C26.3216 8.33572 25.7478 8.33572 25.3939 7.9818L24.7531 7.34099L24.1123 7.9818C24.1046 7.98944 24.0969 7.9969 24.0891 8.0042C26.0194 10.2301 27.1875 13.1348 27.1875 16.3125C27.1875 23.3196 21.5071 29 14.5 29C7.49289 29 1.8125 23.3196 1.8125 16.3125C1.8125 9.92067 6.53857 4.63346 12.6875 3.75358V2.71875C12.187 2.71875 11.7812 2.31301 11.7812 1.8125ZM14.5 5.4375C14.218 5.4375 13.9387 5.44821 13.6625 5.46923C8.04819 5.89631 3.625 10.5883 3.625 16.3125C3.625 22.3186 8.4939 27.1875 14.5 27.1875C20.5061 27.1875 25.375 22.3186 25.375 16.3125C25.375 10.5883 20.9518 5.89631 15.3375 5.46923C15.0613 5.44821 14.782 5.4375 14.5 5.4375Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitionstopwatch);
export default __webpack_public_path__ + "static/media/Competitionstopwatch.abeb9197d3bbe2e86060c107a849f441.svg";
export { ForwardRef as ReactComponent };